<template>
  <div>
    <b-breadcrumb class="breadcrumb-slash mb-1">
      <b-breadcrumb-item :to="{ name: 'dashboard-1' }">
        Dashboard
      </b-breadcrumb-item>
      <b-breadcrumb-item active>
        ดูข้อมูลสินค้า
      </b-breadcrumb-item>
    </b-breadcrumb>

    <b-row>
      <b-col>
        <b-card class="mb-1">
          <div>
            <swiper
              class="swiper-multiple"
              :options="swiperOptions"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            >
              <swiper-slide
                v-for="(data,index) in swiperData"
                :key="index"
              >
                <b-img
                  :src="data.img"
                  fluid
                />
              </swiper-slide>

              <div
                slot="pagination"
                class="swiper-pagination"
              />
              <div
                slot="button-next"
                class="swiper-button-next"
              />
              <div
                slot="button-prev"
                class="swiper-button-prev"
              />
            </swiper>

            <div class="d-flex align-items-center justify-content-start mt-1">
              <b-button
                :to="{ name: 'product-edit', params: { id: productModel.id } }"
                variant="primary"
              >
                Edit
              </b-button>
              <b-button
                variant="outline-danger"
                class="ml-1"
              >
                Delete
              </b-button>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col>
        <b-card title="Product Information">
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Product ID"
                label-for="productId"
              >
                <b-form-input
                  id="productId"
                  v-model="productModel.productId"
                  readonly
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Product BarCode"
                label-for="productBarCode"
              >
                <b-form-input
                  id="productBarCode"
                  v-model="productModel.productBarCode"
                  readonly
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Product Name"
                label-for="productName"
              >
                <b-form-input
                  id="productName"
                  v-model="productModel.productName"
                  readonly
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Product Price"
                label-for="price"
              >
                <b-form-input
                  id="productName"
                  v-model="productModel.price"
                  readonly
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Product Details"
                label-for="productDetail"
              >
                <b-form-textarea
                  id="productDetail"
                  v-model="productModel.productDetail"
                  rows="5"
                  readonly
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col>
        <b-card title="Product Details">
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Product Category"
                label-for="productCategory"
              >
                <b-form-input
                  id="productCategory"
                  v-model="productModel.productCategory"
                  readonly
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Product Size"
                label-for="productSize"
              >
                <b-form-input
                  id="productSize"
                  v-model="productModel.productSize"
                  readonly
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Product Color"
                label-for="productColor"
              >
                <b-form-input
                  id="productColor"
                  v-model="productModel.productColor"
                  readonly
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="More Options"
                label-for="moreOptions"
              >
                <b-form-input
                  id="moreOptions"
                  v-model="productModel.moreOptions"
                  readonly
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Product Stock"
                label-for="productStock"
              >
                <b-form-input
                  id="productStock"
                  v-model="productModel.productStock"
                  readonly
                />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Active Status"
                label-for="status"
              >
                <b-form-input
                  id="status"
                  v-model="productModel.status"
                  readonly
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BRow, BCol, BLink, BCard, BButton, BAvatar,
  BFormGroup, BFormInput, BFormTextarea,
  BCarousel, BCarouselSlide, BImg,
  BBreadcrumb, BBreadcrumbItem,
} from 'bootstrap-vue'

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import { getUserData } from '@/auth/utils'
import productStoreModule from './productStoreModule'
// import UserAddressList from '../users-address/UserAddressList.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BCard,
    BButton,
    BAvatar,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BCarousel,
    BCarouselSlide,
    BImg,
    Swiper,
    SwiperSlide,
    BBreadcrumb,
    BBreadcrumbItem,

    // Local Components
    // UserAddressList,
  },
  data() {
    return {
      /* eslint-disable global-require */
      swiperData: [
        { img: require('@/assets/images/banner/banner-31.jpg') },
        { img: require('@/assets/images/banner/banner-32.jpg') },
        { img: require('@/assets/images/banner/banner-33.jpg') },
        { img: require('@/assets/images/banner/banner-34.jpg') },
        { img: require('@/assets/images/banner/banner-35.jpg') },
      ],
      /* eslint-disable global-require */

      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 30,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    }
  },
  setup() {
    // const userData = getUserData()

    // Register module
    if (!store.hasModule('product')) store.registerModule('product', productStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule('product')) store.unregisterModule('product')
    })

    // const productModel = ref(null)
    const productModel = ref({
      id: 0,
      // eslint-disable-next-line global-require
      avatar: null,
      productId: '',
      productBarCode: '',
      productName: '',
      productDetail: '',
      price: 0,
      productCategory: '',
      productSize: '',
      productColor: '',
      moreOptions: '',
      qtyInStock: 0,
      status: '',
      remark: '',
    })

    store.dispatch('product/getProduct', { id: router.currentRoute.params.id })
      .then(response => {
        productModel.value = response.data
      })
      .catch(error => {

      })

    return {
      productModel,
    }
  },
  methods: {

  },
}
</script>

<style>

</style>
